
import { AsistenteEnLineaUtils } from './utils/asistente-en-linea.utils';
import { HandlerType } from './models/HandlerType';
import { Contexto } from './models/contexto';
import { ConciergeService } from './services/concierge.service';
import { Component, OnInit, OnDestroy, AfterContentInit, Renderer2, Inject, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { VentanaUtils } from './utils/ventana.utils';
import { LocalStorageService } from './services/local-storage.service';
import { alissMensajes } from './components/asistencia-chat/utils/aliss-mensajes';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { FormElements } from './models/FormElements';
import { AsistenciaMenuComponent } from './components/asistencia-menu/asistencia-menu.component';

@Component({
  selector: 'app-asistente-en-linea',
  templateUrl: './asistente-en-linea.component.html',
  styleUrls: ['./asistente-en-linea.component.scss']
})
export class AsistenteEnLineaComponent implements OnInit, AfterContentInit, OnDestroy {
  @Output("loadMantenedor") loadMantenedor = new EventEmitter();
  @ViewChild(AsistenciaMenuComponent, { static: false }) asistenciaMenuComponent: AsistenciaMenuComponent;

  subscriptionHand: Subscription;

  subscriptionClose: Subscription;
  sub: Subscription;
  initHandler: boolean;
  handlerType: HandlerType = new HandlerType();
  formElements: FormElements = new FormElements();
  ctx: Contexto = new Contexto();
  renderChat = false;
  renderEmail = false;
  // botonera que permite seleccionar el tipo de atencion (chat o email)
  renderMenu = true;
  renderMenuArbol = false;
  menuHabilitado = false;
  desplegar = false;
  /**
   * Constructor del componente
   */
  constructor(public conciergeService: ConciergeService,
    private route: ActivatedRoute,
    private utils: AsistenteEnLineaUtils,
    private window: VentanaUtils,
    public dialog: MatDialog,
    private localstorage: LocalStorageService,
    private _render2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private router: Router
  ) {

  }

  /**
   * Inicializacion del componente
   */
  ngOnInit() {

    // Hay que comentar seccion del dominio para que funcione localhost

    // se agrega dominio = bps.gub.uy para evitar errores de permiso al integrar con portal
    const script = this._render2.createElement('script');
    script.type = 'text/javascript';
    script.text = `document.domain=\"${environment.domain}\"; `;
    // Se agrega el script al header
    this._render2.appendChild(this._document.body, script);

    this.initHandler = false;

    this.sub = this.route
      .queryParamMap
      .subscribe((params: any) => {
        // Se hace verdadero al finalizar ngAfterContentInit, asi evitar consumir el servicio sin los query params
        if (this.initHandler) {
          if (params.params.config === "menuAdmin") {
            this.sub.unsubscribe();
            /**if(params.params.idMenu) {
              this.router.navigate(['/config/menu/'], { queryParams: {idMenu: params.params.idMenu} });
            } else {
              this.router.navigate(['/config/home/'], { queryParams: {idMenu: params.params.idMenu} });
            }**/
            this.router.navigate(['/config/home/']);

            this.loadMantenedor.emit();
          }
          else {
            if (params.params.idServicio) {
              // Obtenemos los parametros con los que instanciaron al componente
              this.ctx = this.utils.obtenerParametrosPortal(this.ctx, params);
              this.askForHandler(this.ctx);

              // La presencia del ID de servicio del local storage indica que hay una conversacion activa
              // se valida que se esté entrando al mismo servicio (restriccion: solo un chat activo a la vez)
              console.log('asistente-en-linea.ngOnInit():: this.localstorage.getServiceID(): %s / this.ctx.idServicio: %s / this.ctx.codAsistente: %s', this.localstorage.getServiceID(), this.ctx.idServicio, this.ctx.codAsistente);

              //Si hay participantId es porque hay conversación entonces no quiero mostrar el icono
              // sino abrir el mismo chat
              /* if (this.localstorage.getHandlerType() === 'chat'
                 && this.localstorage.getServiceID() === this.ctx.idServicio) {*/
              const participantID: string = this.localstorage.getParticipantID();
              //if (participantID && participantID.length > 0 && this.localstorage.getServiceID() === this.ctx.idServicio) {
              if (participantID && participantID.length > 0 && this.localstorage.getAsistenteID() === this.ctx.codAsistente) {
                // El ID de servicio en el localstorage solo existe cuando hay un chat activo
                // si retorno al mismo servicio despliego el CHAT, de lo contrario se despliega el menu
                this.renderComponent(this.utils.renderChat);
              } /*else if (this.localstorage.getHandlerType() === 'email') {
                this.renderComponent(this.utils.renderEmail);
              }
              else if (this.localstorage.getHandlerType() === 'menuArbol') {
                this.renderComponent(this.utils.renderMenuArbol);
              }*/ else {
                this.renderComponent(this.utils.renderMenu);
              }

              if (typeof params.params.desplegar != "undefined" && params.params.desplegar == "true") {
                this.desplegar = true;
              }

            }
          }
        }
      });



  }

  ngAfterContentInit() {
    this.initHandler = true;
    // Subscripcion del evento de cierre de ventana
    this.subscriptionClose = this.window.close.subscribe((msg) => {
      const participantID: string = this.localstorage.getParticipantID();
      if (participantID && participantID.length > 0) {
        // Si es un chat y estoy cerrando el chat del servicio que generó el participantId (para multiples pestañas)
        //if (this.handlerType.chat && this.localstorage.getServiceID() === this.ctx.idServicio) {
        //if (this.localstorage.getHandlerType() === 'chat' && this.localstorage.getServiceID() === this.ctx.idServicio) {
        if (this.localstorage.getHandlerType() === 'chat' && this.localstorage.getAsistenteID() === this.ctx.codAsistente) {
          const dialogRef = this.dialog.open(ConfirmModalComponent,
            { data: { message: alissMensajes.confirmacionCierre, btnOK: 'SI', btnNOK: 'NO' }, panelClass: 'custom-modalbox' });
          dialogRef.afterClosed().subscribe(result => {
            if (result && result === ConfirmModalComponent.OK) {
              // Se limplia el localstorage
              this.localstorage.cleanStorage();

              this.renderComponent(this.utils.renderMenu);
              // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
              this.window.setDefaultIframeSize();

              // Chequeo para mostrar le feedback al dar Ok en finalizar la comunicación sólo si hay una 
              // conversación con un asesor. Si el usuario se encuentra en cola y acepta finalizar la comunicación
              // no muestra el feedback.
              if (this.ctx.interactionInfo.agentName) {
                this.abrirEncuesta(this.ctx.codAsistente);
              }
            }
          });
          // No es un chat entonces no limpia el localstorage para mantener el chat en el otro servicio 
        } else {
          // No necesita confirmacion y cierra
          this.renderComponent(this.utils.renderMenu);
          // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
          this.window.setDefaultIframeSize();
        }
      } else {
        // Se limplia el localstorage
        this.localstorage.cleanStorage();

        // Chequea si hubo un participantId y un agente asigando para mostrar o no el PUF.
        // Se cubre el caso de mostrar el feedback cuando hubo una comunicación atendida por un asesor
        // y no mostarlo cuando solo se abre y cierra, cuando está cerrado o cuando está en cola de espera o
        // directamente no hay lugar en cola ya que no hay un agente asignado.
        // En el caso de timeout muestra el feedback si se corta por inactividad y si retoma y queda en cola
        // o si no hay lugar en cola dado que realiza la encuesta sobre la comunicación que se cerró por inactividad.
        // Si retoma con otro asesor, el feedback sería sobre la nueva comunicación.
        if (this.ctx.interactionInfo.participantId && this.ctx.interactionInfo.agentName) {
          this.abrirEncuesta(this.ctx.codAsistente);
        }

        // Chat no activo no necesita confirmacion y cierra
        this.renderComponent(this.utils.renderMenu);
        // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
        this.window.setDefaultIframeSize();

      }

    });
  }

  /**
   * Abre la encuesta siempre que exista un codigo asociado al ID de servicio
   * @param codAsistente ID del asistente
   */
  abrirEncuesta(codAsistente: string) {
    const encuestaFunction = 'ejecutarAbrirEncuesta';
    const ejecutarAbrirEncuesta = parent[encuestaFunction];
    console.log("Buscando Codigo de encuesta para: %s", codAsistente);

    this.conciergeService.getCodigoEncuesta(codAsistente).pipe(take(1)).subscribe((respuesta) => {
      console.log(">>> Resultado:: JSON.stringify(respuesta) %s", JSON.stringify(respuesta));

      if (respuesta && respuesta.codigo) {
        console.log("Codigo de Encuesta: %s", respuesta.codigo);
        ejecutarAbrirEncuesta(respuesta.codigo, [''], {});
      } else {
        console.log("No hay codigo de encuesta para ID servicio: %s", this.ctx.codAsistente);
      }

    });
  }

  ngOnDestroy() {
    this.subscriptionClose.unsubscribe();
  }

  askForHandler(ctx) {
    this.subscriptionHand = this.conciergeService.askForHandler(ctx).pipe(take(1)).subscribe((response) => {
      // Ask for Handler retorna informacion respecto del HandlerType y un mensaje de bienvenida
      // se hace llegar este msg. de bienvenida al comp. asistencia-chat
      if (response.handlerType === 'chat' || response.handlerType === 'both') {
        this.ctx.interactionInfo.welcomeMsg = response.interactionInfo.welcomeMsg;
        this.localstorage.setWelcomeMsg(response.interactionInfo.welcomeMsg);
      }
      // El ask for hander deja el nombre del servicio en el contexto
      this.ctx.descServicio = response.descServicio;

      //se carga idMenu
      this.ctx.idMenu = response.idMenu;
      this.ctx.idFormAsociado = response.idFormAsociado;
      if (response.formElements) {
        this.ctx.formElements.datosEmpresa = response.formElements.datosEmpresa;
        this.ctx.formElements.datosObra = response.formElements.datosObra;
      }
      this.utils.evaluateConcergeResponse(this.handlerType, this.formElements, response);
      if (this.desplegar) {
        this.desplegarAliss();
      }
    });
  }

  /*
  Se retorna el handler necesario (uno de los renders de utils) para poder renderizar el componente que corresponde al
  id actual del contexto.
  */
  async askForHandlerSync(ctx) {
    this.localstorage.removeIdMenuAccion();
    this.localstorage.removeHandlerAccionType();
    return this.conciergeService.askForHandler(ctx).toPromise().then((response: any) => {
      this.ctx.interactionInfo.welcomeMsg = response.interactionInfo.welcomeMsg;

      this.localstorage.setWelcomeMsg(response.interactionInfo.welcomeMsg);

      this.ctx.descServicio = response.descServicio;
      this.localstorage.setIdMenuAccion(response.idMenu);
      this.localstorage.setHandlerAccionType(response.handlerType);
      if (response.handlerType === 'chat') {
        return this.utils.renderChat;
      } else if (response.handlerType === 'email') {
        this.formElements.datosEmpresa = response.formElements.datosEmpresa;
        this.formElements.datosObra = response.formElements.datosObra;
        return this.utils.renderEmail;
      } else if (response.handlerType === 'menuArbol') {
        return this.utils.renderMenuArbol;
      }
      return this.utils.renderMenu;
    })
  }

  renderComponent(component: boolean[]) {
    this.renderChat = component[0];
    this.renderEmail = component[1];
    this.renderMenu = component[2];
    this.renderMenuArbol = component[3];

    /*console.log('AsistenteEnLineaComponent.renderComponent():: component: %s / renderChat: %s / renderEmail: %s / renderMenu: %s / renderMenuArbol: %s / formElements.datosEmrpesa: %s / formElements.datosObra: %s',
      component, this.renderChat, this.renderEmail, this.renderMenu, this.renderMenuArbol, this.formElements.datosEmpresa, this.formElements.datosObra);*/
    if (this.renderEmail) {
      this.window.emailComponentStyle();
      this.localstorage.setHandlerType('email');
    } else if (this.renderChat) {
      this.window.chatComponentStyle();
      this.localstorage.setHandlerType('chat');
    } else if (this.renderMenuArbol) {
      this.window.menuArbolComponentStyle();
      this.localstorage.setHandlerType('menuArbol');
    } else {
      // Si no es email o chat asume icono de asistencia (menu)
      // El refresh y ctl+F5 provocan la ejecucion de este metodo
      this.window.setDefaultIframeSize();
    }
  }

  async emitRenderMenuArbol(event) {
    this.ctx.esFormulario = event.esFormulario || false;
    if (this.ctx.esFormulario) {
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
    }

    this.ctx.idServicio = event.idServicio;
    this.ctx.codAsistente = event.codAsistente;
    this.ctx.codigoTema = event.codigoTema;
    let compToRender = await this.askForHandlerSync(this.ctx);
    this.renderComponent(compToRender)
  }

  /**
   * Metodo utilizado para hacer switch de handler (desde formulario hacia menu-arbol)
   * @param event
   */
  async emitSwitchHandlerEmitter(event) {
    this.ctx.esFormulario = event.esFormulario || false;
    if (this.ctx.esFormulario) {
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
    }
    this.ctx.idServicio = event.idServicio;
    this.ctx.codAsistente = event.codAsistente;
    this.ctx.codigoTema = event.codigoTema;
    this.ctx.idMenu = event.idMenu;
    this.ctx.idFormAsociado = event.idFormAsociado;

    let compToRender = await this.askForHandlerSync(this.ctx);
    this.renderComponent(compToRender)
  }

  async emitChangeContextDataEmitter(event) {
    this.ctx.esFormulario = event.esFormulario || false;
    if (this.ctx.esFormulario) {
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
    }
    this.ctx.idServicio = event.idServicio;
    this.ctx.codAsistente = event.codAsistente;
    this.ctx.codigoTema = event.codigoTema;
    this.ctx.idMenu = event.idMenu;
    this.ctx.idFormAsociado = event.idFormAsociado;

  }

  public loadScript({ id, url }) {
    return new Promise((resolve, reject) => {
      let script = this._render2.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = '';
      script.src = url;
      script.id = id;
      script.onload = () => {
        resolve({ id: id, loaded: true, status: 'Loaded' });
      };
      script.onerror = (error: any) => resolve({ id: id, loaded: false, status: 'Loaded' });
      script.async = true;
      script.defer = true;
      this._render2.appendChild(this._document.body, script);
    });
  }

  @HostListener('document:ejecutarAccionMessageChannel', ['$event'])
  //se debe mantener en esta ubicación para que funcione correctamente
  handleEjecutarAccion(event: CustomEvent) {
    this.resolverAccionChannelMessaging(event);
  }

  resolverAccionChannelMessaging(event: CustomEvent) {
    debugger
    var accion = event.detail.accion;
    if (accion == 'desplegar-aliss') {
      this.desplegarAliss();
    }
  }

  desplegarAliss() {
    var tipoAsistente = '';

    if (this.handlerType.chat) {
      tipoAsistente = 'chat';
    }
    else if (this.handlerType.email) {
      tipoAsistente = 'email'
    }
    else if (this.handlerType.menuArbol) {
      tipoAsistente = 'menuArbol'
    }
    if (tipoAsistente) {
      this.asistenciaMenuComponent.onClickRenderComponent(tipoAsistente)
    }
  }
}
